import Hero from './components/Hero';
import Services from './components/Services';
import PricingTable from './components/PricingTable';
import Packages from './components/Packages';
import Booking from './components/Booking';
import About from './components/About';
import Testimonials from './components/Testimonials';
import RenderService from './components/RenderService';
import Contact from './components/Contact';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'HomeAndConstructionBusiness',
  name: 'Art Throng Home',
  url: siteUrl,
  description:
    'Art Throng Home offers expert interior design, professional cleaning, reliable maintenance, and custom renovations for vacation rentals and permanent residents in Goa and Mumbai.',
  telephone: '+91-000-000-0000',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Panjim',
    addressRegion: 'Goa',
    addressCountry: 'IN',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: '15.491',
    longitude: '73.827',
  },
  areaServed: [
    { '@type': 'City', name: 'Goa' },
    { '@type': 'City', name: 'Mumbai' },
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Home Services',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Interior Design & Styling' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Home Cleaning Services' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Home Maintenance' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Renovation & Carpentry' } },
    ],
  },
  aggregateRating: {
    '@type': 'AggregateRating',
    ratingValue: '4.9',
    reviewCount: '500',
    bestRating: '5',
  },
};

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Hero />
      <Services />
      <PricingTable />
      <Packages />
      <Booking />
      <About />
      <Testimonials />
      <RenderService />
      <Contact />
    </div>
  );
}
